import { ColumnTable, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FinancialBlockConfig } from '../api';

const dictPrefix = 'financialPortal.settings.financialBlock';

interface Options {
  onEdit: (config: FinancialBlockConfig) => void;
  onDelete: (config: FinancialBlockConfig) => void;
}

export function useConfigColumns({
  onEdit,
  onDelete,
}: Options): ColumnTable<FinancialBlockConfig>[] {
  const { t } = useTranslation();

  return useMemo<ColumnTable<FinancialBlockConfig>[]>(
    () => [
      {
        columnName: 'overdueDays',
        headerText: t(`${dictPrefix}.columns.overdueDays`),
        thClassName: 'text-center',
        tdClassName: 'text-center',
      },
      {
        columnName: 'overdueDebtsCount',
        headerText: t(`${dictPrefix}.columns.overdueDebtsCount`),
        thClassName: 'text-center',
        tdClassName: 'text-center',
      },
      {
        columnName: 'id',
        headerText: t(`${dictPrefix}.columns.actions`),
        thClassName: 'text-center',
        tdClassName: 'text-center',
        width: 90,
        // Acciones sólo con icono, patrón de
        // courseGroups/parts/ActionCell.tsx: `btn p-0` con aria-label y title
        // en el mismo texto, accesible y con tooltip sin claves nuevas.
        cellFormat: ({ row }) => (
          <div className="d-flex justify-content-center" style={{ gap: 8 }}>
            <button
              type="button"
              className="btn p-0"
              aria-label={t(`${dictPrefix}.columns.edit`)}
              title={t(`${dictPrefix}.columns.edit`)}
              onClick={() => onEdit(row)}
            >
              <Icon size="15" name="edit" color="primary" />
            </button>
            <button
              type="button"
              className="btn p-0"
              aria-label={t(`${dictPrefix}.columns.delete`)}
              title={t(`${dictPrefix}.columns.delete`)}
              onClick={() => onDelete(row)}
            >
              <Icon size="15" name="trash" color="primary" />
            </button>
          </div>
        ),
      },
    ],
    [t, onEdit, onDelete],
  );
}
